<template>
  <q-form
    ref="formRef"
    no-error-focus
    class="grid grid-cols-2 gap-x-16 gap-y-24 mt-24"
  >
    <OInput
      v-model="model.titulo"
      size="md"
      type="text"
      :label="t('title')"
      :rules="[(v) => !!v?.length]"
      class="col-span-2"
    />

    <OInput
      v-model="model.descricao"
      size="lg"
      type="textarea"
      stack-label
      :label="t('description')"
      :placeholder="t('writeHere')"
      :rules="[(v) => !!v?.length]"
      class="col-span-2 showPlaceholderOnStack"
    />

    <OInput
      v-model="model.ordem"
      size="md"
      type="number"
      :label="t('order')"
    />

    <OInput
      v-model="model.pontos"
      size="md"
      type="text"
      :label="t('points')"
      :rules="[(v) => !!v?.toString().length]"
    />
  </q-form>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { watch } from 'vue'
import OInput from 'components/Input/OInput.vue'

const { t } = useI18n()

const props = defineProps({
  alternativa: { type: Object, required: true },
})

const model = ref({ ...props.alternativa })

watch(
  model.value,
  (newVal) => {
    emit('update:modelValue', newVal)
  },
  { deep: true }
)

const emit = defineEmits(['update:modelValue'])

const formRef = ref(null)

const validate = () => formRef.value?.validate()

defineExpose({ validate })
</script>

<style lang="scss" scoped></style>
